import type { FC, PropsWithChildren } from "react";

const Masonry: FC<PropsWithChildren> = ({ children }) => (
	<div className="gap-px-30 mt-px-30 grid auto-rows-min grid-cols-1 md:auto-rows-[90px] md:grid-cols-2 lg:auto-rows-[175px] lg:grid-cols-3">
		{children}
	</div>
);

export const BlogMasonry: FC<PropsWithChildren> = ({ children }) => (
	<div className="gap-px-30 mt-px-30 grid auto-rows-min grid-cols-1 md:grid-cols-2 lg:[grid-template-columns:repeat(3,1fr)]">
		{children}
	</div>
);

export default Masonry;
